import React, { useState } from 'react';
import { GenPage, SegmentControl } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const BreakingPlates = () => {
  const t = useT();
  const [count, setCount] = useState('3');

  return (
    <GenPage
      title={t('page.breakingPlates.title')}
      contentType="breakingPlates"
      description={t('page.breakingPlates.desc')}
      outputLabel={t('page.breakingPlates.output')}
      extraOptions={
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-gray-500 font-medium whitespace-nowrap">{t('label.plates')}</span>
          <SegmentControl
            options={['1', '3', '5', '10']}
            value={count}
            onChange={setCount}
          />
        </div>
      }
      extraInstructions={`Number of plates to generate: ${count}`}
    />
  );
};
